import React from 'react'

import DayUseBox from "../Box/BoxPlans";

import * as S from './styled'
import BoxPremium from "../Box/BoxPremium";

const PlansComponent = () => {

    const planGold = {
        name: "GOLD",
        color: "#DEAE0D",
        benefits: [
            {title: "Acesso desconto exclusivos", active: true},
            {title: "Acesso a comunidade RM Sports", active: true},
            {title: "Acesso aos treinos presenciais", active: true},
            {title: "Feedback Training Peaks", active: true},
            {title: "Comunicação via Whatsapp", active: true},
            {title: "Treinos personalizados", active: true},
            {title: "Kit inicial de boas-vindas", active: true},
            {title: "Alteração de planilha", active: true},
            {title: "Conta Training Peaks", active: true},
            {title: "Estratégia pré prova (alvo anual)", active: true},
            {title: "Estratégia e análise de performance pré e pós prova (todas as provas)", active: false},
            {title: "Musculação personalizada", active: false},
            {title: "Sessão mensal com Psicóloga Esportiva", active: false},
        ]
    }

    const planPremium = {
        name: "PREMIUM",
        color: "#FF8200",
        benefits: [
            {title: "Acesso desconto exclusivos", active: true},
            {title: "Acesso a comunidade RM Sports", active: true},
            {title: "Acesso aos treinos presenciais", active: true},
            {title: "Feedback Training Peaks", active: true},
            {title: "Comunicação via Whatsapp", active: true},
            {title: "Treinos personalizados", active: true},
            {title: "Kit inicial de boas-vindas", active: true},
            {title: "Alteração de planilha", active: true},
            {title: "Conta Training Peaks", active: true},
            {title: "Estratégia pré prova (alvo anual)", active: true},
            {title: "Estratégia e análise de performance pré e pós prova (todas as provas)", active: true},
            {title: "Musculação personalizada", active: false},
            {title: "Sessão mensal com Psicóloga Esportiva", active: false},
        ]
    }

    const planDiamond = {
        name: "DIAMANTE",
        color: "#00B2A9",
        benefits: [
            {title: "Acesso desconto exclusivos", active: true},
            {title: "Acesso a comunidade RM Sports", active: true},
            {title: "Acesso aos treinos presenciais", active: true},
            {title: "Feedback Training Peaks", active: true},
            {title: "Comunicação via Whatsapp", active: true},
            {title: "Treinos personalizados", active: true},
            {title: "Kit inicial de boas-vindas", active: true},
            {title: "Alteração de planilha", active: true},
            {title: "Conta Training Peaks", active: true},
            {title: "Estratégia pré prova (alvo anual)", active: true},
            {title: "Estratégia e análise de performance pré e pós prova (todas as provas)", active: true},
            {title: "Musculação personalizada", active: true},
            {title: "Sessão mensal com Psicóloga Esportiva", active: true},
        ]
    }

    const boxPremium = {
        "title": "Planos Premium e Diamante",
        "content": "Criamos um <strong>serviço diferenciado</strong> para atender quem busca grandes resultados e mais qualidade na sua prática esportiva. Acreditamos que treinos com dados é tornar seu treino mais eficiente. Com base no seu <strong>histórico de treinos</strong>, estabelecemos seu perfil de habilidades e condicionamento, aplicando <strong>treinos específicos</strong> com metas claramente definidas e zonas de treinamento que lhe permitirão tirar o máximo proveito do seu treino."
    }


    return (
        <S.Wrapper id="planos">
            <S.Content>
                <S.Title>Planos</S.Title>
                <S.BoxPlans>
                    <DayUseBox name={planGold.name} color={planGold.color} benefits={planGold.benefits}/>
                    <DayUseBox name={planPremium.name} color={planPremium.color} benefits={planPremium.benefits}/>
                    <DayUseBox name={planDiamond.name} color={planDiamond.color} benefits={planDiamond.benefits}/>
                </S.BoxPlans>
                <BoxPremium title={boxPremium.title} content={boxPremium.content}/>
            </S.Content>
        </S.Wrapper>
    );
};

export default PlansComponent;
